import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://gruwcer.com';
const SITE_NAME = 'Gruwcer Delivery';
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`;

const PageSEO = ({ title, description, keywords, path, type = 'website', noIndex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Book Taxi & Delivery Services Online`;
  const fullUrl = path ? `${BASE_URL}${path}` : BASE_URL;
  const defaultDesc = 'Gruwcer Delivery - Fast, safe, and affordable taxi booking and delivery services. Real-time tracking, 24/7 availability.';
  const desc = description || defaultDesc;
  const defaultKeywords = 'taxi booking, ride hailing, delivery service, book a ride, online taxi, cab booking, package delivery, courier service, real-time tracking';
  const kw = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
    </Helmet>
  );
};

export default PageSEO;
